<template>
    <div>
        <div class="row" style="margin-top: 1rem;">
            <div style="text-align: center; width: 100%;">
                <ul class="visual-check-legend">
                    <li><div class="circle circle-red"></div> Requires immediate attention</li>
                    <li><div class="circle circle-orange"></div> Advisory</li>
                    <li><div class="circle circle-green"></div> OK</li>
                    <li><div class="circle circle-grey"></div> Not Checked</li>
                </ul>
            </div>
            <div>
                <table class="table tyre-state-table" style="margin-top: 0;">
                <thead>
                    <tr>
                        <th style="width: 100px;"></th>
                        <th style="font-size: 10px; vertical-align: middle;">
                            <span class="material-icons">warning</span>
                        </th>
                        <th style="font-size: 10px; vertical-align: middle;">
                            <span class="material-icons">priority_high</span>
                        </th>
                        <th style="font-size: 10px; vertical-align: middle;">
                            <span class="material-icons">check</span>
                        </th>
                        <th style="font-size: 10px; vertical-align: middle;">
                            <span class="material-icons">remove</span>
                        </th>
                        <th style="width: 100px;">Depth (mm)</th>
                        <th style="width: 150px;">Detail</th>
                        <th style="width: 150px;">Comments</th>
                    </tr>
                </thead>
                <tyre-state-question-row
                    label="Front Left" v-model="internalValue.additional_data.front_left" @input="replicateValues(); updated()"
                ></tyre-state-question-row>
                <tyre-state-question-row
                    label="Front Right" v-model="internalValue.additional_data.front_right" @input="e => { desynchronize('front_right', e); updated() }"
                ></tyre-state-question-row>
                <tyre-state-question-row
                    label="Rear Left" v-model="internalValue.additional_data.rear_left" @input="e => { desynchronize('rear_left', e); updated() }"
                ></tyre-state-question-row>
                <tyre-state-question-row
                    label="Rear Right" v-model="internalValue.additional_data.rear_right" @input="e => { desynchronize('rear_right', e); updated() }"
                ></tyre-state-question-row>
                <tyre-state-question-row
                    label="Spare" v-model="internalValue.additional_data.spare" @input="e => { desynchronize('spare', e); updated() }"
                ></tyre-state-question-row>
            </table>
            </div>
        </div>
    </div>
</template>

<script>
import KeenTyreSizeInput from "../forms/controls/KeenTyreSizeInput";
import {AnswerOutcomes, AnswerSchema, TyreStateAnswerSchema} from "../../classes/Api/Inspection";
import TyreStateQuestionRow from "./TyreStateQuestionRow";
import {isEmpty, cloneDeep, isNull, isNumber, isString} from "lodash";
export default {
    components: {TyreStateQuestionRow, KeenTyreSizeInput},
    props: {
        question: {
            type: Object,
            required: true,
        },
        answer: {
            type: Object,
            required: true,
        }
    },
    created() {
        if (!this.answer) {
            this.setDefaultAnswer()
        } else {
            this.setAnswer(this.answer)
        }

    },
    watch: {
        answer: {
            handler(n) {
                this.setAnswer(n)
            },
            deep: true
        }
    },
    data() {
        return {
            valid: false,
            internalValue: null,
            synchronizedTyres: ['front_right', 'rear_left', 'rear_right', 'spare']
        }
    },
    methods: {
        setDefaultAnswer() {
            this.setAnswer(AnswerSchema({ additional_data: TyreStateAnswerSchema() }))
        },
        setAnswer(answer) {
            this.internalValue = AnswerSchema({ 
                ...answer, 
                additional_data: TyreStateAnswerSchema(answer.additional_data ?? {})
             })

            if (answer.outcome && answer.outcome !== '') {
                this.synchronizedTyres = []
            }

            this.evaluateValidity()
        },
        isNotNumberOrString(val) {
            return !(isString(val) && val.length > 0 || isNumber(val) && val > 0)
        },
        evaluateValidity() {
            let validity = true
            let keys = ['front_right', 'front_left', 'rear_left', 'rear_right', 'spare']

            for (let i in keys) {
                let item = this.internalValue.additional_data[keys[i]]

                if (item.outcome !== AnswerOutcomes.OUTCOME_SKIPPED && (
                    this.isNotNumberOrString(item.depth_inner) || this.isNotNumberOrString(item.depth_centre) || this.isNotNumberOrString(item.depth_outer) ||
                    this.isNotNumberOrString(item.make) || this.isNotNumberOrString(item.spec))
                ) {
                    validity = false
                    break;
                }
            }

            this.valid = validity

            this.setAnswerOutcome()
        },
        setAnswerOutcome() {
            if (!this.valid) {
                this.internalValue.outcome = null
                return
            }

            let keys = ['front_right', 'front_left', 'rear_left', 'rear_right', 'spare']

            let outcomes = []

            for (let i in keys) {
                outcomes.push(this.internalValue.additional_data[keys[i]].outcome)
            }

            if (outcomes.find(i => i === AnswerOutcomes.OUTCOME_FAILED)) {
                this.internalValue.outcome = AnswerOutcomes.OUTCOME_FAILED
            } else if (outcomes.find(i => i === AnswerOutcomes.OUTCOME_ADVISORY)) {
                this.internalValue.outcome = AnswerOutcomes.OUTCOME_ADVISORY
            } else {
                this.internalValue.outcome = AnswerOutcomes.OUTCOME_PASSED
            }
        },
        updated() {
            this.evaluateValidity()

            this.$emit('input', cloneDeep(this.internalValue))
        },
        desynchronize(key, e) {
            if (!isEmpty(e.spec) || !isEmpty(e.make)) {
                this.synchronizedTyres = this.synchronizedTyres.filter(i => i !== key)
            }
        },
        replicateValues() {
            const keys = ['spec', 'make']

            for (let tyre in this.synchronizedTyres) {
                for (let key in keys) {
                    this.internalValue.additional_data[this.synchronizedTyres[tyre]][keys[key]] =
                        this.internalValue.additional_data['front_left'][keys[key]]
                }
            }
        }
    }
}
</script>

<style lang="scss">
    table.tyre-state-table {
        tbody tr,
        thead tr {
            td, th {
                text-align: center;
                width: 25px;
                padding: 0;
            }
        }

        tbody tr {
            td:first-child { font-weight: bold; }
            td:nth-child(2) {
                background: #f9a2a4;
                cursor: pointer;
                padding: 0;
                .material-icons { padding-top: 5px; }
                &:hover { background: darken(#f9a2a4, 10%); }
            }
            td:nth-child(3) {
                background: #ecdb92;
                cursor: pointer;
                padding: 0;
                .material-icons { padding-top: 5px; }
                &:hover { background: darken(#ecdb92, 10%); }
            }
            td:nth-child(4) {
                background: #98cc9c;
                cursor: pointer;
                padding: 0;
                .material-icons { padding-top: 5px; }
                &:hover { background: darken(#98cc9c, 10%); }
            }
            td:nth-child(5) {
                background: #d0d0d0;
                cursor: pointer;
                padding: 0;
                .material-icons { padding-top: 5px; }
                &:hover { background: darken(#d0d0d0, 10%); }
            }
        }

        thead tr {
            th:nth-child(2) { background: #ea5155; color: white; }
            th:nth-child(3) { background: #fae070; color: white; }
            th:nth-child(4) { background: #65d06d; color: white; }
            th:nth-child(5) { background: #999; color: white; }
        }

        .ui-textbox .ui-textbox__input { text-align: center; }
        .ui-textbox { margin: 0; }
    }

    .visual-check-legend {
        list-style: none;
        padding: 0;
        li { display: inline-block; padding: 0 1rem; }

        .circle {
            display: inline-block;
            width: 20px; height: 20px;
            vertical-align: middle;
            margin: 0 .5rem;

            &.circle-red { background:#ea5155; }
            &.circle-orange { background:#fae070; }
            &.circle-green { background:#65d06d; }
            &.circle-grey { background:#999; }
        }
    }
</style>